// Material UI components
import { Box, Theme, Typography } from "@mui/material";

interface PaceHeaderProps {
    title: string | JSX.Element;
}

const PaceHeader = ({ title }: PaceHeaderProps): JSX.Element => {
    return (
        <Box mb={3}>
            <Typography
                variant="h5"
                sx={(theme: Theme) => ({
                    paddingLeft: theme.spacing(4),
                    fontWeight: 600,
                    height: 100,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: theme.palette.background.blue,
                    color: theme.palette.neutrals.dark,
                })}
            >
                {title}
            </Typography>
        </Box>
    );
};

export default PaceHeader;
